export default __webpack_public_path__ + "static/media/Ballroll_00147.7713a2b7.png";